import { useEffect, useState } from 'react';

const CHANGE_EVENT = 'havu-scan-allowance-changed';
const DAY_MS = 24 * 60 * 60 * 1000;
let memoryNextScanAt = 0;

const readNextScanAt = (): number => {
  return memoryNextScanAt > Date.now() ? memoryNextScanAt : 0;
};

export const recordScanAllowance = (nextScanAt: unknown): void => {
  memoryNextScanAt = typeof nextScanAt === 'number' && Number.isFinite(nextScanAt) && nextScanAt > Date.now()
    ? nextScanAt
    : 0;
  window.dispatchEvent(new Event(CHANGE_EVENT));
};

export const useScanAllowance = (): number => {
  const [nextScanAt, setNextScanAt] = useState(readNextScanAt);

  useEffect(() => {
    const refresh = () => setNextScanAt(readNextScanAt());
    window.addEventListener(CHANGE_EVENT, refresh);
    const timer = nextScanAt
      ? window.setTimeout(refresh, Math.min(Math.max(nextScanAt - Date.now(), 0), DAY_MS))
      : undefined;
    return () => {
      window.removeEventListener(CHANGE_EVENT, refresh);
      window.clearTimeout(timer);
    };
  }, [nextScanAt]);

  return nextScanAt;
};
